import { PolymerElement } from "@polymer/polymer/polymer-element.js";
import "@nuskin/ns-style-elements";

import template from "./ns-step.html";

class NsStep extends PolymerElement {
  static get is() {
    return "ns-step";
  }

  ready() {
    super.ready();
  }

  constructor() {
    super();

    // this.addEventListener('touchstart', () => alert('hello'), true);
  }

  static get template() {
    let htmlElement = document.createElement("TEMPLATE");
    htmlElement.innerHTML = template;
    return htmlElement;
  }

  static get properties() {
    return {
      icon: {
        type: String,
        value: "nuskin:icon-stepper-future",
        reflectToAttribute: true
      },

      label: {
        type: String,
        reflectToAttribute: true
      },

      completed: {
        type: Boolean,
        reflectToAttribute: true,
        value: false
      }
    };
  }

  _next() {
    this.completed = true;
    this.icon = "nuskin:icon-success-filled";
  }

  _previous() {
    this.completed = false;
  }
}
customElements.define(NsStep.is, NsStep);
